/**
 * @param {?} path
 * @return {?}
 */
function environmentLoader(path) {
    return new Promise(function (resolve, reject) {
        // make the http request object.
        var /** @type {?} */ xmlhttp = new XMLHttpRequest(), /** @type {?} */ method = 'GET', /** @type {?} */ url = path;
        // open.
        xmlhttp.open(method, url, true);
        // when we get a response, 
        xmlhttp.onload = function () {
            if (xmlhttp.status === 200) {
                resolve(JSON.parse(xmlhttp.responseText));
            }
            else {
                resolve({});
            }
        };
        // send the request.
        xmlhttp.send();
    });
}
var EnvironmentLoader = /** @class */ (function () {
    function EnvironmentLoader() {
    }
    return EnvironmentLoader;
}());
/**
 * Generated bundle index. Do not edit.
 */
export { environmentLoader, EnvironmentLoader };
//# sourceMappingURL=ecova-environment-loader.es5.js.map
